module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "barButton",
    attrs: {
      "id": _vm.button.id
    },
    on: {
      "mouseup": _vm.up
    }
  }, [_vm._v(_vm._s(_vm.button.fn))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3876005a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/F3dButton.vue
// module id = 26
// module chunks = 0